<template>
  <main>
    <div class="hp-bg-color-dark-90 min-vh-100 d-flex">
      <sidebar />
      
      <div class="hp-main-layout hp-main-layout-responsive">
        <app-header />
        <div class="hp-main-layout-content-responsive">
          <vue-page-transition name="fade-in-up">
            <router-view />
          </vue-page-transition>
        </div>
        <app-footer />
      </div>
    </div>
    <scroll-to-top />
  </main>
</template>

<script>
import Sidebar from "./components/menu/Sidebar.vue";
import AppHeader from "./components/header/index.vue";
import AppFooter from "./components/footer/AppFooter.vue";
import Breadcrumb from "./components/content/breadcrumb/Breadcrumb.vue";
import ScrollToTop from "@/layouts/components/scroll-to-top";

export default {
  components: {
    Sidebar,
    AppHeader,
    AppFooter,
    Breadcrumb,
    ScrollToTop,
  },
};
</script>

<style scoped>
/* Override problematic layout constraints */
.hp-main-layout-responsive {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden; /* Prevent layout overflow issues */
}

.hp-main-layout-content-responsive {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 16px;
  
  /* Ensure proper responsive behavior */
  width: 100%;
  min-height: 0; /* Important for flex child scrolling */
}

/* Mobile responsive fixes */
@media (max-width: 768px) {
  .hp-main-layout-content-responsive {
    padding: 12px 8px;
  }
}

@media (max-width: 576px) {
  .hp-main-layout-content-responsive {
    padding: 8px 4px;
  }
}

/* Ensure cards inside are fully responsive */
.hp-main-layout-content-responsive :deep(.b-card),
.hp-main-layout-content-responsive :deep(.card) {
  width: 100% !important;
  max-width: 100% !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
}

/* Fix container fluid issues */
.hp-main-layout-content-responsive :deep(.container-fluid) {
  padding-left: 0 !important;
  padding-right: 0 !important;
  max-width: 100% !important;
}

/* Ensure proper scrolling for tables */
.hp-main-layout-content-responsive :deep(.table-responsive) {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

/* Mobile card optimizations */
@media (max-width: 767.98px) {
  .hp-main-layout-content-responsive :deep(.user-card) {
    margin-bottom: 0.75rem !important;
    border-radius: 8px !important;
  }
  
  .hp-main-layout-content-responsive :deep(.documents-grid) {
    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr)) !important;
    gap: 12px !important;
  }
}
</style>